import React from 'react';

/**
 * SmartImage
 *
 * Rewrites any legacy `/api/uploads/...` URL to `/uploaded/...` so the
 * image is served by the frontend's static CDN instead of the backend
 * container. The backend can sleep (Kubernetes scale-to-zero) without
 * affecting image delivery.
 *
 * This makes the fix work IMMEDIATELY on the live site, even if the
 * backend database still contains legacy /api/uploads/ URLs — they
 * will be transparently rewritten on every image render.
 */
const rewriteImageUrl = (src) => {
  if (typeof src !== 'string') return src;
  // Convert "/api/uploads/xxx.jpg?v=123" → "/uploaded/xxx.jpg?v=123"
  if (src.startsWith('/api/uploads/')) {
    return src.replace('/api/uploads/', '/uploaded/');
  }
  // Handle absolute URLs too (e.g. https://jannesmann.de/api/uploads/...)
  if (src.includes('/api/uploads/')) {
    return src.replace('/api/uploads/', '/uploaded/');
  }
  return src;
};

const SmartImage = ({
  src,
  alt = '',
  className = '',
  style,
  onClick,
  'data-testid': dataTestId,
  ...rest
}) => {
  const finalSrc = rewriteImageUrl(src);

  return (
    <img
      src={finalSrc}
      alt={alt}
      className={className}
      style={style}
      onClick={onClick}
      loading="eager"
      decoding="async"
      data-testid={dataTestId}
      {...rest}
    />
  );
};

export default SmartImage;
